export default "__VITE_ASSET__C9Z47czG__"